<template>
  <div class="home">
    <div class="title" :style="titleStyle">
      <div class="text" style="cursor: pointer" @click="pushIndex">
        <img :src="require('@/assets/logo4.png')" />
      </div>

      <div style="display: flex; align-items: center">
        <div class="block_1" v-show="isShow">
          <el-input
            placeholder="点击搜索文献、期刊……"
            size="normal"
            @focus="search"
            type="text"
          >
          </el-input>
          <!-- <img :src="require('@/assets/img/searchlogo.png')" /> -->
          <div class="icon" @click="search">
            <img :src="require('@/assets/img/searchlogo.png')" />
          </div>
        </div>
        <div v-if="loginStatus === '1'" class="track">
          <span @click="goTrack"> 我的跟踪板块 </span>
        </div>
        <div>
          <!-- <div style="margin-top: 10px; display: flex">
            <el-input
              v-model="value"
              clearable
              placeholder="请输入内容"
              style="margin-right: 10px"
            ></el-input>
            <el-button
              style="background: #286fdd; color: #fff"
              @click="pushBaitu"
              >百度</el-button
            >
            <el-button
              @click="pushWeibo"
              style="margin-right: 10px; background: #286fdd; color: #fff"
              >微博</el-button
            >
          </div> -->
        </div>
        <div v-if="loginStatus === '1' && userInfo.enabled" class="info">
          <img class="info_img" :src="imgUrl" alt="" v-if="imgUrl !== ''" />
          <img
            style="margin-right: 10px; width: 40px"
            src="@/assets/用户.png"
            alt=""
            v-else
          />
          <el-dropdown @command="handleCommand">
            <span
              class="el-dropdown-link"
              style="font-weight: 800"
              v-if="userName"
            >
              {{ userName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <span
              class="el-dropdown-link"
              style="font-weight: 800"
              v-else
              @click="login"
            >
              未登录
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="text-align: center">
              <el-dropdown-item command="b">我的收藏</el-dropdown-item>
              <el-dropdown-item command="c" divided>我的消息</el-dropdown-item>
              <el-dropdown-item command="d" divided>基本信息</el-dropdown-item>
              <el-dropdown-item command="e" divided>栏目排序</el-dropdown-item>
              <el-dropdown-item v-if="isAdmin" command="f" divided>关键字配置</el-dropdown-item>
              <el-dropdown-item v-if="isAdmin" command="g" divided>系统推送</el-dropdown-item>
              <el-dropdown-item v-if="isAdmin" command="h" divided>医学前沿</el-dropdown-item>
              <el-dropdown-item v-if="isAdmin" command="i" divided>轮播图片</el-dropdown-item>
              <el-dropdown-item v-if="isAdmin" command="j" divided>平台统计</el-dropdown-item>
              <!-- <el-dropdown-item v-if="isAdmin" command="h" divided
                >后台管理</el-dropdown-item
              > -->
              <el-dropdown-item command="a" divided>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else class="login">
          <span @click="login(true)">登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      userName: "",
      keywords: "",
      isShow: true,
      imgUrl: "",
      isAdmin: false,
    };
  },
  created() {
    this.init();
    if (
      JSON.parse(sessionStorage.getItem("user"))?.account === "admin" ||
      JSON.parse(sessionStorage.getItem("user"))?.account === "18158120689"
    ) {
      this.isAdmin = true;
    }
  },
  computed: {
    loginStatus() {
      return sessionStorage.getItem("isLogin");
    },
    userInfo() {
      return JSON.parse(sessionStorage.getItem("user"));
    },
  },
  methods: {
    pushBaitu() {
      var herf = "https://www.baidu.com/s?";
      var temp =
        herf +
        `ie=utf-8&f=8&rsv_bp=${this.value}&rsv_idx=1&tn=baidu&wd=${this.value}&fenlei=256&rsv_pq=b29ff6220000fd7e&rsv_t=204fJLwgF4lGrvLALuRT9mEF6seYPiq913i%2BP0AuvbS4QyDbpIAr0tB6DEs&rqlang=cn&rsv_enter=0&rsv_dl=tb&rsv_sug3=2&rsv_sug1=1&rsv_sug7=100&rsv_btype=i&prefixsug=z&rsp=2&inputT=4043&rsv_sug4=6322`;
      window.open(temp, "_blank");
    },
    pushWeibo() {
      var herf = "https://s.weibo.com/weibo?";
      var temp = herf + `q=${this.value}`;
      window.open(temp, "_blank");
    },
    async init() {
      if (parseInt(sessionStorage.getItem("isLogin")) === 1) {
        const res = JSON.parse(sessionStorage.getItem("user"));
        this.userName = res.name;
        this.$emit("getUserName", res);
        this.imgUrl = require(`@/assets/defaultBucket/${res.avatar}.jpg`);
      }
    },
    pushIndex() {
      this.$router.push("/index");
    },
    goTrack() {
      let routerUrl = this.$router.resolve({
        path: "/track",
      });
      window.open(routerUrl.href);
    },
    search() {
      if (parseInt(this.loginStatus) === 1) {
        let routerUrl = this.$router.resolve({
          path: "/search",
        });
        window.open(routerUrl.href, "blank");
      } else {
        this.$message.error("请登录后重试");
      }
    },
    handleCommand(command) {
      if (command == "a") {
        sessionStorage.clear();
        this.$router.push("/login");
      } else if (command == "b") {
        this.$router.push("/user/collection");
      } else if (command == "c") {
        this.$router.push("/user/mymsg");
      } else if (command == "e") {
        this.$router.push("/user/queueList");
      } else if (command == "f") {
        this.$router.push("/user/keywordConfig");
      } else if (command == "g") {
        this.$router.push("/user/articleConfig");
      } else if (command == "h") {
        this.$router.push("/user/medicalFrontierInfo");
      } else if (command == "i") {
        this.$router.push("/user/rotationNewsSetting");
      }else if (command == "j") {
        this.$router.push("/user/platformStatistics");
      } else {
        this.$router.push("/user/basicmsg");
      }
    },
    login() {
      // if (parseInt(this.loginStatus) !== 1) {
      //   this.$message({
      //     message: "请先登录",
      //     type: "warning",
      //   });
      // }
      this.$router.push("/login");
    },
  },
  props: ["titleStyle"],
};
</script>

<style lang="scss" scoped>
.home {
  background-color: #f7f7f7;
}
::v-deep .el-input__inner {
  background-color: #4273b2;
}
.title1 {
  padding: 20px 5% 20px 5%;
}
.track {
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  margin-right: 20px;
}
.title {
  background-color: #4273b2;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 5% 20px 5%;
  .text {
    width: 241px;
    height: 80px;
    color: #fff;
    .text_1 {
      width: 240px;
      height: 33px;
      // color: rgba(0, 106, 191, 1);
      font-size: 24px;
      font-family: PingFangSC-Semibold;
      text-align: left;
      white-space: nowrap;
      line-height: 33px;
    }
    .text_2 {
      height: 13px;
      // color: rgba(0, 106, 191, 1);
      transform: scale(0.8);
      font-size: 12px;
      margin-left: -18px;
      font-family: PingFangSC-Medium;
      transform: scale(0.85);
      white-space: nowrap;
      line-height: 13px;
      margin-top: 4px;
    }
    .text_3 {
      width: 200px;
      height: 28px;
      // color: rgba(0, 0, 0, 0.9);
      font-size: 20px;
      font-family: PingFangSC-Semibold;
      text-align: left;
      white-space: nowrap;
      line-height: 28px;
      margin-top: 4px;
    }
  }
  ::-webkit-input-placeholder {
    /* WebKit browsers，webkit内核浏览器 */

    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #ffffff;
  }
  .block_1 {
    width: 240px;
    height: 30px;
    margin-right: 20px;
    position: relative;
    cursor: pointer;
    line-height: 40px;
    ::v-deep .el-input__inner {
      cursor: pointer;
      // border-radius: 25px;
      border: 1px solid #ffffff;
    }
    ::v-deep .el-icon-search {
      margin: 8px;
    }
    .icon {
      background-color: rgba(11, 112, 193, 0.1);

      position: absolute;
      top: 4px;
      left: 205px;
      cursor: pointer;
    }
  }
  .info {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .info_img {
      margin-right: 10px;
      width: 40px;
      border-radius: 50%;
    }
    .el-dropdown {
      color: #fff;
    }
  }
}

.login {
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
</style>

